// extracted by mini-css-extract-plugin
export default {"home":"Home_home__CMw1J","home__container":"Home_home__container__5DMcK"};